// extracted by mini-css-extract-plugin
module.exports =  {"authorize":"aes39gOimSN8IGpUlXFV"};